import config from 'config'
import graphql from 'api/graphql'
import { load } from 'recaptcha-v3'
import { oauthTokenSelector, isAuthenticatedSelector } from 'selectors/app'
import {
  doAuthenticateFromToken,
  doGoogleOauth,
  doOfficeOauth,
} from 'actions/auth'
import { doReloadTokenInfo } from 'ducks/tokens/actions'
import { basicFields as accountFields } from 'api/account'
import { signupFields as userFields } from 'ducks/currentUser/api'
import {
  getSignupAccountAttributes,
  getMarketingAttribution,
} from '../../utils'
import { V2_COMPANY_PAGE } from '../pages'

import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE } from '../../types'

function getReCaptchaToken() {
  return load(config.google_recaptcha_site_key).then(recaptcha =>
    recaptcha.execute('signup')
  )
}

export function doSignupAccount(params) {
  return (dispatch, getState) => {
    return getReCaptchaToken().then(reCaptchaToken => {
      const state = getState()
      const token = oauthTokenSelector(state)

      const signup = {
        authenticity_token: 'TOKEN',
        recaptcha_token: reCaptchaToken,
        source: 'marketing',
        user: {
          account_attributes: {
            ...getSignupAccountAttributes(),
            type: 'helpdesk',
            onboarding_version: 2,
          },
          consents: {
            marketing: true,
            privacy_and_terms: true,
          },
          email: params.emailInput,
          marketing_attribution: getMarketingAttribution(),
        },
        utf8: '✓',
      }

      dispatch({
        type: SIGNUP_REQUEST,
        data: { signup },
      })

      const mutation = `
        mutation signupAccount(
          $input: SignupInput!
        ){
          signupAccount(
            input: $input
          ) {
            account {
              ${accountFields}
            }
            user {
              ${userFields}
            }
          }
        }
      `

      const variables = {
        input: signup,
      }

      return graphql(token, mutation, variables)
        .then(res => {
          const data = res.json.data
          const { account, user } = data.signupAccount
          // HACK (jscheel): Having three dispatches here is terrible, but
          // refactoring how our actions and reducers respond to signups and
          // logins will have to wait for another day.
          dispatch({
            type: SIGNUP_SUCCESS,
            payload: { account, user },
          })
          dispatch(doAuthenticateFromToken(user.token, user.expiresAt))
          dispatch(doReloadTokenInfo())
          dispatch({
            type: V2_COMPANY_PAGE,
          })
        })
        .catch(err => {
          dispatch({
            type: SIGNUP_FAILURE,
            payload: { error: err },
          })
        })
    })
  }
}

export function doRedirectToHomeIfAuthenticated() {
  return (dispatch, getState) => {
    const state = getState()
    if (isAuthenticatedSelector(state)) {
      window.location = '/'
    }
  }
}

export function doGoogleSignup() {
  return dispatch => {
    dispatch(doGoogleOauth(V2_COMPANY_PAGE, { signup: true }))
  }
}

export function doOfficeSignup() {
  return dispatch => {
    dispatch(doOfficeOauth(V2_COMPANY_PAGE, { signup: true }))
  }
}
